// horizontal projection
export function projX (angle: number): number {
  return Math.abs(vectorX(angle))
}

// vertical projection
export function projY (angle: number): number {
  return Math.abs(vectorY(angle))
}

export function vectorX (angle: number): number {
  return Math.round(Math.cos(angle * Math.PI / 180))
}

export function vectorY (angle: number): number {
  return Math.round(Math.sin(angle * Math.PI / 180))
}

// direction multiplier (direction along the axis)
export function directionX (angle: number): number {
  return Math.sign(Math.cos(angle * Math.PI / 180) || 1)
}

export function directionY (angle: number): number {
  return Math.sign(Math.sin(angle * Math.PI / 180) || 1)
}

export function compare (a: any, b: any) {
  if (a == null || b == null || a.length !== b.length) {
    return false
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false
    }
  }
  return true
}
